"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: user/errors.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fuser%2Ferrors.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.errorCodeToJSON = exports.errorCodeFromJSON = exports.ErrorCode = void 0;
/* eslint-disable */
const protobufPackage = 'com.step.user.proto';
var ErrorCode;
(function (ErrorCode) {
    ErrorCode["FAILED_TO_ISSUE_REWARD"] = "FAILED_TO_ISSUE_REWARD";
    ErrorCode["REDEMPTION_LIMIT_REACHED"] = "REDEMPTION_LIMIT_REACHED";
    ErrorCode["DOB_REQUIRED"] = "DOB_REQUIRED";
    ErrorCode["FIRST_NAME_REQUIRED"] = "FIRST_NAME_REQUIRED";
    ErrorCode["LAST_NAME_REQUIRED"] = "LAST_NAME_REQUIRED";
    ErrorCode["SSN_REQUIRED"] = "SSN_REQUIRED";
    ErrorCode["AGE_GATED"] = "AGE_GATED";
    ErrorCode["INVALID_DOB"] = "INVALID_DOB";
    ErrorCode["PHONE_UNSUPPORTED_COUNTRY"] = "PHONE_UNSUPPORTED_COUNTRY";
    ErrorCode["PHONE_UNSUPPORTED_PHONE_COUNTRY"] = "PHONE_UNSUPPORTED_PHONE_COUNTRY";
    ErrorCode["INVALID_SSN"] = "INVALID_SSN";
    ErrorCode["ADDRESS_INVALID"] = "ADDRESS_INVALID";
    ErrorCode["ADDRESS_MISSING_PRIMARY_NUMBER"] = "ADDRESS_MISSING_PRIMARY_NUMBER";
    ErrorCode["ADDRESS_MISSING_SECONDARY_INFO"] = "ADDRESS_MISSING_SECONDARY_INFO";
    ErrorCode["ADDRESS_INVALID_SECONDARY_INFO"] = "ADDRESS_INVALID_SECONDARY_INFO";
    ErrorCode["ADDRESS_ZIP_POBOX_DELIVERY_ONLY"] = "ADDRESS_ZIP_POBOX_DELIVERY_ONLY";
    ErrorCode["ADDRESS_UNSUPPORTED_COUNTRY"] = "ADDRESS_UNSUPPORTED_COUNTRY";
    ErrorCode["LAST_NAME_TOO_SHORT"] = "LAST_NAME_TOO_SHORT";
    ErrorCode["ADDRESS_UNSUPPORTED_STATE"] = "ADDRESS_UNSUPPORTED_STATE";
    ErrorCode["PHONE_SWITCH_TO_VOIP_UNSUPPORTED"] = "PHONE_SWITCH_TO_VOIP_UNSUPPORTED";
    ErrorCode["PROFILE_NOT_FOUND"] = "PROFILE_NOT_FOUND";
    ErrorCode["EMAIL_INVALID"] = "EMAIL_INVALID";
    ErrorCode["INELIGIBLE_FOR_MANAGED_USER_GRADUATION"] = "INELIGIBLE_FOR_MANAGED_USER_GRADUATION";
    ErrorCode["SPONSORED_CRYPTO_ACCOUNT_CLOSURE_REQUIRED"] = "SPONSORED_CRYPTO_ACCOUNT_CLOSURE_REQUIRED";
    ErrorCode["SPONSORED_STOCK_ACCOUNT_CLOSURE_REQUIRED"] = "SPONSORED_STOCK_ACCOUNT_CLOSURE_REQUIRED";
    ErrorCode["TOO_MANY_DOB_UPDATES"] = "TOO_MANY_DOB_UPDATES";
    ErrorCode["DOB_UPDATE_IS_RESTRICTED"] = "DOB_UPDATE_IS_RESTRICTED";
    ErrorCode["NOT_KYCED"] = "NOT_KYCED";
    ErrorCode["LEGAL_NAME_REQUIRED"] = "LEGAL_NAME_REQUIRED";
    ErrorCode["SSO_NOT_FOUND"] = "SSO_NOT_FOUND";
    ErrorCode["UNRECOGNIZED"] = "UNRECOGNIZED";
})(ErrorCode || (exports.ErrorCode = ErrorCode = {}));
function errorCodeFromJSON(object) {
    switch (object) {
        case 0:
        case 'FAILED_TO_ISSUE_REWARD':
            return ErrorCode.FAILED_TO_ISSUE_REWARD;
        case 1:
        case 'REDEMPTION_LIMIT_REACHED':
            return ErrorCode.REDEMPTION_LIMIT_REACHED;
        case 6:
        case 'DOB_REQUIRED':
            return ErrorCode.DOB_REQUIRED;
        case 8:
        case 'FIRST_NAME_REQUIRED':
            return ErrorCode.FIRST_NAME_REQUIRED;
        case 9:
        case 'LAST_NAME_REQUIRED':
            return ErrorCode.LAST_NAME_REQUIRED;
        case 10:
        case 'SSN_REQUIRED':
            return ErrorCode.SSN_REQUIRED;
        case 11:
        case 'AGE_GATED':
            return ErrorCode.AGE_GATED;
        case 15:
        case 'INVALID_DOB':
            return ErrorCode.INVALID_DOB;
        case 16:
        case 'PHONE_UNSUPPORTED_COUNTRY':
            return ErrorCode.PHONE_UNSUPPORTED_COUNTRY;
        case 18:
        case 'PHONE_UNSUPPORTED_PHONE_COUNTRY':
            return ErrorCode.PHONE_UNSUPPORTED_PHONE_COUNTRY;
        case 19:
        case 'INVALID_SSN':
            return ErrorCode.INVALID_SSN;
        case 20:
        case 'ADDRESS_INVALID':
            return ErrorCode.ADDRESS_INVALID;
        case 21:
        case 'ADDRESS_MISSING_PRIMARY_NUMBER':
            return ErrorCode.ADDRESS_MISSING_PRIMARY_NUMBER;
        case 22:
        case 'ADDRESS_MISSING_SECONDARY_INFO':
            return ErrorCode.ADDRESS_MISSING_SECONDARY_INFO;
        case 23:
        case 'ADDRESS_INVALID_SECONDARY_INFO':
            return ErrorCode.ADDRESS_INVALID_SECONDARY_INFO;
        case 24:
        case 'ADDRESS_ZIP_POBOX_DELIVERY_ONLY':
            return ErrorCode.ADDRESS_ZIP_POBOX_DELIVERY_ONLY;
        case 25:
        case 'ADDRESS_UNSUPPORTED_COUNTRY':
            return ErrorCode.ADDRESS_UNSUPPORTED_COUNTRY;
        case 26:
        case 'LAST_NAME_TOO_SHORT':
            return ErrorCode.LAST_NAME_TOO_SHORT;
        case 27:
        case 'ADDRESS_UNSUPPORTED_STATE':
            return ErrorCode.ADDRESS_UNSUPPORTED_STATE;
        case 28:
        case 'PHONE_SWITCH_TO_VOIP_UNSUPPORTED':
            return ErrorCode.PHONE_SWITCH_TO_VOIP_UNSUPPORTED;
        case 29:
        case 'PROFILE_NOT_FOUND':
            return ErrorCode.PROFILE_NOT_FOUND;
        case 30:
        case 'EMAIL_INVALID':
            return ErrorCode.EMAIL_INVALID;
        case 31:
        case 'INELIGIBLE_FOR_MANAGED_USER_GRADUATION':
            return ErrorCode.INELIGIBLE_FOR_MANAGED_USER_GRADUATION;
        case 32:
        case 'SPONSORED_CRYPTO_ACCOUNT_CLOSURE_REQUIRED':
            return ErrorCode.SPONSORED_CRYPTO_ACCOUNT_CLOSURE_REQUIRED;
        case 33:
        case 'SPONSORED_STOCK_ACCOUNT_CLOSURE_REQUIRED':
            return ErrorCode.SPONSORED_STOCK_ACCOUNT_CLOSURE_REQUIRED;
        case 34:
        case 'TOO_MANY_DOB_UPDATES':
            return ErrorCode.TOO_MANY_DOB_UPDATES;
        case 35:
        case 'DOB_UPDATE_IS_RESTRICTED':
            return ErrorCode.DOB_UPDATE_IS_RESTRICTED;
        case 36:
        case 'NOT_KYCED':
            return ErrorCode.NOT_KYCED;
        case 37:
        case 'LEGAL_NAME_REQUIRED':
            return ErrorCode.LEGAL_NAME_REQUIRED;
        case 38:
        case 'SSO_NOT_FOUND':
            return ErrorCode.SSO_NOT_FOUND;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return ErrorCode.UNRECOGNIZED;
    }
}
exports.errorCodeFromJSON = errorCodeFromJSON;
function errorCodeToJSON(object) {
    switch (object) {
        case ErrorCode.FAILED_TO_ISSUE_REWARD:
            return 'FAILED_TO_ISSUE_REWARD';
        case ErrorCode.REDEMPTION_LIMIT_REACHED:
            return 'REDEMPTION_LIMIT_REACHED';
        case ErrorCode.DOB_REQUIRED:
            return 'DOB_REQUIRED';
        case ErrorCode.FIRST_NAME_REQUIRED:
            return 'FIRST_NAME_REQUIRED';
        case ErrorCode.LAST_NAME_REQUIRED:
            return 'LAST_NAME_REQUIRED';
        case ErrorCode.SSN_REQUIRED:
            return 'SSN_REQUIRED';
        case ErrorCode.AGE_GATED:
            return 'AGE_GATED';
        case ErrorCode.INVALID_DOB:
            return 'INVALID_DOB';
        case ErrorCode.PHONE_UNSUPPORTED_COUNTRY:
            return 'PHONE_UNSUPPORTED_COUNTRY';
        case ErrorCode.PHONE_UNSUPPORTED_PHONE_COUNTRY:
            return 'PHONE_UNSUPPORTED_PHONE_COUNTRY';
        case ErrorCode.INVALID_SSN:
            return 'INVALID_SSN';
        case ErrorCode.ADDRESS_INVALID:
            return 'ADDRESS_INVALID';
        case ErrorCode.ADDRESS_MISSING_PRIMARY_NUMBER:
            return 'ADDRESS_MISSING_PRIMARY_NUMBER';
        case ErrorCode.ADDRESS_MISSING_SECONDARY_INFO:
            return 'ADDRESS_MISSING_SECONDARY_INFO';
        case ErrorCode.ADDRESS_INVALID_SECONDARY_INFO:
            return 'ADDRESS_INVALID_SECONDARY_INFO';
        case ErrorCode.ADDRESS_ZIP_POBOX_DELIVERY_ONLY:
            return 'ADDRESS_ZIP_POBOX_DELIVERY_ONLY';
        case ErrorCode.ADDRESS_UNSUPPORTED_COUNTRY:
            return 'ADDRESS_UNSUPPORTED_COUNTRY';
        case ErrorCode.LAST_NAME_TOO_SHORT:
            return 'LAST_NAME_TOO_SHORT';
        case ErrorCode.ADDRESS_UNSUPPORTED_STATE:
            return 'ADDRESS_UNSUPPORTED_STATE';
        case ErrorCode.PHONE_SWITCH_TO_VOIP_UNSUPPORTED:
            return 'PHONE_SWITCH_TO_VOIP_UNSUPPORTED';
        case ErrorCode.PROFILE_NOT_FOUND:
            return 'PROFILE_NOT_FOUND';
        case ErrorCode.EMAIL_INVALID:
            return 'EMAIL_INVALID';
        case ErrorCode.INELIGIBLE_FOR_MANAGED_USER_GRADUATION:
            return 'INELIGIBLE_FOR_MANAGED_USER_GRADUATION';
        case ErrorCode.SPONSORED_CRYPTO_ACCOUNT_CLOSURE_REQUIRED:
            return 'SPONSORED_CRYPTO_ACCOUNT_CLOSURE_REQUIRED';
        case ErrorCode.SPONSORED_STOCK_ACCOUNT_CLOSURE_REQUIRED:
            return 'SPONSORED_STOCK_ACCOUNT_CLOSURE_REQUIRED';
        case ErrorCode.TOO_MANY_DOB_UPDATES:
            return 'TOO_MANY_DOB_UPDATES';
        case ErrorCode.DOB_UPDATE_IS_RESTRICTED:
            return 'DOB_UPDATE_IS_RESTRICTED';
        case ErrorCode.NOT_KYCED:
            return 'NOT_KYCED';
        case ErrorCode.LEGAL_NAME_REQUIRED:
            return 'LEGAL_NAME_REQUIRED';
        case ErrorCode.SSO_NOT_FOUND:
            return 'SSO_NOT_FOUND';
        case ErrorCode.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.errorCodeToJSON = errorCodeToJSON;
//# sourceMappingURL=errors.js.map